import React, { useEffect, useState } from 'react'
import { CardEventDashboard } from '../../../../components/Dashboard/CardEventDashboard'
import { NothingToShow } from '../../../../components/Dashboard/NothingToShow'
import { eventService } from '../../../../services/event.service'

export const ListEventsDeleted = () => {
  const [fetch, setFetched] = useState(false)
  const [eventsDeleted, setEventsDeleted] = useState([])

  useEffect(() => {
    const getEvents = async () => {
      const events = await eventService.getAllEventsDeleted()
      setEventsDeleted(events)
    }
    getEvents()
  }, [fetch])
  console.log(eventsDeleted)
  return (
    <>
      <h1 className="mb-2 mb-md-0 text-primary">
        Eventos eliminados
      </h1>
      <br />
      {/* Events */}
      <div className="container-fluid">
        <div className="row">
          {
            eventsDeleted.length === 0 && (<NothingToShow />)
          }
          {
            eventsDeleted.map((e, index) => (
              <div key={index} className="col-12">
                <CardEventDashboard
                  {...e} setFetched={setFetched}
                  fetch={fetch}
                  fromPublicados={1}
                  fromAprobados={0}
                  fromEliminados={1}
                />
              </div>
            ))
          }
        </div>
      </div>
    </>
  )
}
